import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors
} from '@angular/forms';
import { MerchantDto } from '@up/data';
import { Observable, of } from 'rxjs';
import { Schedule } from '../../../../interfaces/src/lib/schedule.interface';
import { isOrderRequestDateValid } from '../order/order-request-date.helper';
 
export function orderRequestedDateValidator(
  merchant: MerchantDto,
  schedules: Map<string, Schedule>,
  orderType: string
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    return of(isOrderRequestDateValid(control.value, merchant, schedules, orderType));
  }
}